module.exports = __webpack_public_path__ + "img/monitor-icon15.d5210fa3.png";